import { gql } from '../../__generated__/gql'

export const COMPLETE_WELCOME_GUIDE_STEP_MUTATION = gql(`
  mutation completeWelcomeGuideStep($stepTitle: LabWelcomeGuideStepEnum!) {
    completeWelcomeGuideStep(input: {stepTitle: $stepTitle}) {
      user {
        id
        communityProfile {
          welcomeGuideSteps {
            stepTitle
            completedAt
          }
        }
      }
    }
  }
`)
